(function () {
    'use strict';

    angular.module('app.hbIntegration', [
        // Angular modules
        'ngRoute',

        // Custom modules
        'treeControl'
        // 3rd Party Modules

    ]);
})();